/* eslint-disable */
import React, { useState,useEffect } from 'react';
import { AuthenticatedTemplate, UnauthenticatedTemplate, useMsal } from '@azure/msal-react';
import { ContentRoutes } from './ContentRoutes';
import { loginRequest } from './authConfig';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
// import Logo from './Images/AssetEdgeSolutionsLogo.png';
import Logo from './Images/AssetEdgeLogo.png';
import Navbar from "react-bootstrap/Navbar";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import 'rsuite/dist/rsuite-no-reset.min.css';
import 'react-toastify/dist/ReactToastify.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import './cutsomKendoStyles.css'
import { Link } from 'react-router-dom';
import SessionTimeout from './components/UiComponents/SessionTimeout';
import logo from './Images/AES_Logo.svg';
import {setScriptKey} from '@progress/kendo-licensing';
import './App.css';

const licenseKey = process.env.REACT_APP_KENDO_UI_LICENSE;
setScriptKey(licenseKey);


// import '@boldreports/javascript-reporting-controls/Content/v2.0/tailwind-light/bold.report-viewer.min.css';
// import '@boldreports/javascript-reporting-controls/Scripts/v2.0/common/bold.reports.common.min';
// import '@boldreports/javascript-reporting-controls/Scripts/v2.0/common/bold.reports.widgets.min';
// import '@boldreports/javascript-reporting-controls/Scripts/v2.0/bold.report-viewer.min';
// //Reports react base
// import '@boldreports/react-reporting-components/Scripts/bold.reports.react.min';
function App() {

  return (
    <React.Fragment>
      <SessionTimeout />
      <AuthenticatedTemplate>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <ContentRoutes />
          {/* <ChatBot/> */}
        </LocalizationProvider>
      </AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <LoginLayout />
      </UnauthenticatedTemplate>
    </React.Fragment>
  );
}

export default App;

export const LoginLayout = () => {
  const { instance } = useMsal();
  const handleLogin = () => {
    instance.loginRedirect(loginRequest).catch((e) => {
      console.log(e);
    });
  }
  return (
    <>
      <Navbar variant="dark" className="navbarStyle pri-Background p-3">
        <Link style={{ textDecoration: 'none', color: "white" }}>
          <h3 className="m-0 hoverHand" style={{ fontWeight: 'normal' }}>
            <img src={logo} alt="" className='me-3' />
            ASSET EDGE
          </h3>
        </Link>
      </Navbar>
      <br />
      <br />
      <h5>
        <center >
          <span className='d-block py-2'>
           {process.env.REACT_APP_NEXTGEN_PLATFORMNAME}
          </span>
          <span className='d-block py-2'>
            Click Login to Continue
          </span>
          <button className='p-lg-btn' onClick={() => handleLogin()}>
            Login
          </button>
        </center>
      </h5>
      <br />
      <br />
    </>
  )
}

